import { formatDateTime, formatNumber } from '../format'
import type { ImportRun } from '../types'

interface Props {
  importRuns: ImportRun[]
}

const STATUS_LABELS: Record<string, string> = {
  running: 'Rodando',
  succeeded: 'Concluído',
  failed: 'Falha',
}

const STATUS_CLASSES: Record<string, string> = {
  running: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400',
  succeeded: 'bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400',
  failed: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400',
}

const SOURCE_LABELS: Record<string, string> = {
  litellm_gateway: 'LiteLLM direto',
  fleet_api: 'Fleet API',
}

export default function ImportRunsPanel({ importRuns }: Props) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="px-4 py-3 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Importações recentes</h3>
      </div>
      <div className="divide-y divide-border">
        {importRuns.map((run) => (
          <div key={run.id} className="px-4 py-3 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="font-mono text-xs text-foreground truncate">{run.instanceName}</div>
              <div className="text-xs text-muted-foreground">{formatDateTime(run.startedAt)}</div>
              {run.errorSummary && <div className="text-xs text-red-600 truncate max-w-xl">{run.errorSummary}</div>}
            </div>
            <div className="flex items-center gap-3 text-xs text-muted-foreground">
              <span>{SOURCE_LABELS[run.source] || run.source}</span>
              <span>{formatNumber(run.rowsSeen)} lidas</span>
              <span>{formatNumber(run.rowsInserted)} novas</span>
              <span>{formatNumber(run.rowsUpdated)} atualizadas</span>
              <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full font-medium
                  ${STATUS_CLASSES[run.status] || 'bg-accent text-muted-foreground'}`}
              >
                {STATUS_LABELS[run.status] || run.status}
              </span>
            </div>
          </div>
        ))}
        {importRuns.length === 0 && (
          <div className="px-4 py-6 text-sm text-muted-foreground text-center">
            Nenhuma importação registrada.
          </div>
        )}
      </div>
    </div>
  )
}
